import { useQueries } from '@tanstack/react-query';
import { useAxios } from './use-axios';
import { loadTvProgramGuide } from '../api/load-tv-program-guide';
import { loadTvProgramGuideNonSrg } from '../api/load-tv-program-guide-non-srg';
import { queryKeys } from '../config/use-query';
export const useTvGuide = (date, providers, initialData) => {
  const axios = useAxios();
  const results = useQueries({
    queries: providers.map(provider => ({
      queryKey: [queryKeys.TvProgramGuide(date, provider), axios],
      queryFn: () => provider === 'non-srg' ? loadTvProgramGuideNonSrg(date, axios, true) : loadTvProgramGuide(date, axios, [provider], true),
      initialData: initialData?.[queryKeys.TvProgramGuide(date, provider)]
    }))
  });

  // The following code prevents the tv-guide channels from reordering while loading the different channel packages.
  // The channel package for each tv-guide provider is loading at the same time but will only be displayed if the content above is loaded as well.
  const data = results.flatMap((result, index) => {
    // find first loading entry
    const loadingIndex = results.findIndex(res => res.isLoading);
    if (loadingIndex === -1 || loadingIndex > index) {
      return result.data ?? [];
    }
    return [];
  });
  const isAtLeastOneLoading = results.some(result => result.isLoading);
  return {
    programs: data.length > 0 || !isAtLeastOneLoading ? data : undefined,
    isLoading: isAtLeastOneLoading,
    isError: results.every(result => result.isError)
  };
};